import { call, takeEvery, put } from 'redux-saga/effects';
import { isNil, prop, assoc, compose } from 'ramda';
import { retrieveUriParam, createRedirectUrl, LocalStorage } from '../../utils/helpers';
import { validateClient, retrieveObject, validateCode } from './util';
import { APP_VERIFY_PARAMS, APP_VERIFY_CODE_EXISTS } from './index';
import { showError } from '../alert';
import { setLoggedUser, setClient } from '../auth';

function* validateInitialQueryParams() {
  const clientId = retrieveUriParam('client_id');
  const redirectUri = retrieveUriParam('redirect_uri');
  const appName = retrieveUriParam('app_name');
  try {
    const client = yield call(validateClient, { clientId, redirectUri });
    yield put(setClient(client));
    const spec = {
      idToken: '',
      refreshToken: '',
      accessToken: ''
    };
    const userTokens = retrieveObject({ userTokens: spec });
    if (Object.keys(userTokens).every(k => !isNil(userTokens[k]))) {
      yield put(
        setLoggedUser({
          username: LocalStorage.get('user.username'),
          client_name: appName || client.name || 'Stack Sports',
          app_url: compose(
            createRedirectUrl,
            assoc('redirectUri', redirectUri),
            prop('userTokens')
          )(userTokens)
        })
      );
    }
  } catch (error) {
    yield put(showError({ text: 'Invalid client_id or redirect_uri', status: 'InvalidURL' }));
  }
}

function* validateCodeExists() {
  try {
    yield call(validateCode);
  } catch (error) {
    yield put(showError({ text: 'Missing code parameter', status: 'InvalidURL' }));
  }
}

const appSagas = [
  takeEvery(APP_VERIFY_PARAMS, validateInitialQueryParams),
  takeEvery(APP_VERIFY_CODE_EXISTS, validateCodeExists)
];

export default appSagas;



// WEBPACK FOOTER //
// ./src/core/app/sagas.js